import React, { useState, useEffect } from "react";
import { Table, Button, Typography, Modal, Form, Select, message } from "antd";
import "./Styles/Dashboard.css";
import OrderDetailsModal from "./OrderDetailsModal"; // Import the OrderDetailsModal component
import moment from "moment"; // Import Moment library for date formatting
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import logo from "./Imaged/logo.png"; // Adjust the path based on your file structure
import { toWords } from "number-to-words";

const { Link } = Typography;
const { Option } = Select;
const { confirm } = Modal; // Import Modal.confirm

const Dashboard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrder2, setSelectedOrder2] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState([]);
  const [staffData, setStaffData] = useState([]);

  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);
    fetchpackedOrders(VendorId);
  }, [refreshTrigger]);
  const fetchpackedOrders = async (VendorId) => {
    console.log("Fetching packed orders for vendor:", VendorId);
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/fetch_packed_orders",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vendor_id: VendorId }),
        }
      );
      if (!response.ok) {
        setOrderData([]);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched packed orders:", data);
      setOrderData(data);
    } catch (error) {
      console.error("Error fetching packed orders:", error.message);
      // You might want to set some error state here to display to the user
    }
  };

  const markOrderReadyForShipment = async (orderId) => {
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/order_vendor_details",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vendorId, orderId: orderId.order_id }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to mark order as ready for shipment");
      }
      setRefreshTrigger((prev) => prev + 1); // Trigger a re-fetch
      message.success("Order marked as ready for shipment successfully");
    } catch (error) {
      console.error("Error marking order as ready for shipment:", error);
      message.error("Error marking order as ready for shipment");
    }
  };
  const handleOrderDetails = async (orderId) => {
    console.log(vendorId);
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/order_details",
        {
          method: "POST", // Use POST if you are sending data in the body
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            vendorId,
            orderId,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch order details");
      }
      const data = await response.json();
      console.log("Order Details:", data);
      // Display modal with order details
      setSelectedOrder(data); // Store order details in state
      setIsModalVisible(true); // Show modal
    } catch (error) {
      console.error("Error fetching order details:", error);
      // Handle error state if needed
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "order_id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "orderId",
      render: (text) => (
        <Link onClick={() => handleOrderDetails(text)}>{text}</Link>
      ),
    },
    {
      title: "Packed Date & Time",
      dataIndex: "packed_time",
      key: "order_date",
      render: (text) => formatDate(text), // Render using custom format function
    },
    {
      title: "Customer Name",
      key: "customer_name",
      render: (text, record) =>
        `${record.shipping_first_name} ${record.shipping_last_name}`,
    },
    {
      title: "Customer Phone",
      dataIndex: "shipping_phone",
      key: "shipping_phone",
    },
    {
      title: "Invoice",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => generatePDF(record)}>
          Invoice
        </Button>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => showAssignModal2(record)}>
          Ready for Shipment
        </Button>
      ),
    },
  ];

  // const generatePDF = () => {
  //   const doc = new jsPDF("p", "pt", "a4");

  //   // Add logo image
  //   const img = new Image();
  //   img.src = logo;
  //   doc.addImage(img, "PNG", 40, 40, 100, 60); // width: 100, height: 60

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(16);
  //   doc.text("Tax Invoice/Bill of Supply/Cash Memo", 300, 50);
  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "normal");
  //   doc.text("(Original for Recipient)", 300, 70);

  //   // Sold By Section
  //   doc.setFont("helvetica", "bold");
  //   doc.text("SOLD BY:", 40, 130);
  //   doc.setFont("helvetica", "normal");
  //   doc.text("CIVU CLOTHING COMPANY", 40, 150);
  //   doc.text("1st Floor, 5/129 Avinashilingampalayam", 40, 165);
  //   doc.text("Palangarai Village, Avinashi", 40, 180);
  //   doc.text("Thirumuruganpoondi, Tiruppur", 40, 195);
  //   doc.text("Tamil Nadu, 641654", 40, 210);

  //   doc.setFont("helvetica", "bold");
  //   doc.text("PAN:", 40, 235);
  //   doc.text("GST: 33AEPPU3730E1ZG", 40, 250);

  //   // Billing and Shipping Address
  //   doc.setFont("helvetica", "bold");
  //   doc.text("BILLING ADDRESS:", 400, 130);
  //   doc.setFont("helvetica", "normal");
  //   doc.text("SABARI", 400, 150);
  //   doc.text("7 Fresh Bakery, Valayashettiyur,", 400, 165);
  //   doc.text("Erode, Tamil Nadu, 637107", 400, 180);

  //   doc.setFont("helvetica", "bold");
  //   doc.text("SHIPPING ADDRESS:", 400, 210);
  //   doc.setFont("helvetica", "normal");
  //   doc.text("SABARI", 400, 230);
  //   doc.text("7 Fresh Bakery, Valayashettiyur,", 400, 245);
  //   doc.text("Erode, Tamil Nadu, 637107", 400, 260);

  //   // Invoice Details
  //   doc.text("Invoice Date : 17/05/2024", 400, 290);
  //   doc.text("Invoice Number: 202405001", 400, 305);
  //   doc.text("Order Date: 17/05/2024", 400, 320);
  //   doc.text("Order Number: 21975", 400, 335);

  //   // Add Table for Product Details
  //   const tableData = [
  //     [
  //       "1",
  //       "Trendy Men’s Five Sleeve Printed T-shirt – XL",
  //       "269.78",
  //       "0",
  //       "1",
  //       "269.78",
  //       "9% 9%",
  //       "29.61 CGST 29.61 SGST",
  //       "329",
  //     ],
  //     [
  //       "",
  //       "Shipping Charges",
  //       "41",
  //       "0",
  //       "",
  //       "41",
  //       "9% 9%",
  //       "4.5 CGST 4.5 SGST",
  //       "50",
  //     ],
  //   ];

  //   doc.autoTable({
  //     startY: 360,
  //     head: [
  //       [
  //         "S.No",
  //         "Description",
  //         "Unit Price in Rs.",
  //         "Discount in Rs.",
  //         "Qty",
  //         "Net Amount in Rs.",
  //         "Tax Rate",
  //         "Tax Amount in Rs.",
  //         "Total Amount in Rs.",
  //       ],
  //     ],
  //     body: tableData,
  //     theme: "grid",
  //     headStyles: { fillColor: [100, 100, 100] }, // Adjust colors as needed
  //     margin: { top: 10 },
  //   });

  //   // Add Footer Details
  //   const finalY = doc.lastAutoTable.finalY + 10;
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`Total: 379`, 470, finalY + 20);
  //   doc.text(
  //     "Amount in Words: Three Hundred Seventy-nine only",
  //     40,
  //     finalY + 40
  //   );

  //   doc.setFont("helvetica", "normal");
  //   doc.text("Date & Time: 17/05/2024, 15:26:33 hrs", 40, finalY + 80);
  //   doc.text("Invoice Value: 379.00", 300, finalY + 80);
  //   doc.text("Authorized Signatory", 470, finalY + 80);

  //   doc.text("Thank you for shopping with us!", 40, finalY + 110);
  //   doc.text(
  //     "Note: This invoice is for the item mentioned above only.",
  //     40,
  //     finalY + 125
  //   );
  //   doc.text(
  //     "In case of any difficulty, please contact support@aptope.com",
  //     40,
  //     finalY + 140
  //   );

  //   doc.save("Invoice.pdf");
  // };

  // const generatePDF = async (record) => {
  //   console.log("Record:", record);

  //   // Fetch order details from API
  //   const response = await fetch(
  //     "https://app-tl2d3sc25q-uc.a.run.app/api/order_details",
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         vendorId: record.vendor_id, // Use vendor_id from the record
  //         orderId: record.order_id, // Use order_id from the record
  //       }),
  //     }
  //   );

  //   const data = await response.json();
  //   console.log("Fetched Data:", data);

  //   // Extract billing and items from fetched data
  //   const billing = data.billing || {};
  //   const orderItems = data.items || [];
  //   const totalOrderValue = data.total_order_value || 0;

  //   const doc = new jsPDF("p", "pt", "a4");

  //   // Add logo image
  //   const img = new Image();
  //   img.src = logo; // Assuming you have a logo variable defined
  //   doc.addImage(img, "PNG", 40, 40, 100, 60);

  //   // Title and Subtitle
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(16);
  //   doc.text("Tax Invoice/Bill of Supply/Cash Memo", 300, 50);
  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "normal");
  //   doc.text("(Original for Recipient)", 300, 70);

  //   // Sold By Section
  //   doc.setFont("helvetica", "bold");
  //   doc.text("SOLD BY:", 40, 130);
  //   doc.setFont("helvetica", "normal");
  //   doc.text("CIVU CLOTHING COMPANY", 40, 150);
  //   doc.text("1st Floor, 5/129 Avinashilingampalayam", 40, 165);
  //   doc.text("Palangarai Village, Avinashi", 40, 180);
  //   doc.text("Thirumuruganpoondi, Tiruppur", 40, 195);
  //   doc.text("Tamil Nadu, 641654", 40, 210);
  //   doc.setFont("helvetica", "bold");
  //   doc.text("PAN:", 40, 235);
  //   doc.text("GST: 33AEPPU3730E1ZG", 40, 250);

  //   // Billing Address
  //   doc.setFont("helvetica", "bold");
  //   doc.text("BILLING ADDRESS:", 400, 130);
  //   doc.setFont("helvetica", "normal");
  //   doc.text(
  //     `${billing.first_name || ""} ${billing.last_name || ""}`,
  //     400,
  //     150
  //   );
  //   doc.text(`${billing.phone || ""}`, 400, 165); // Billing phone
  //   doc.text(billing.address || "", 400, 180); // Billing address

  //   // Order Details
  //   const orderDate = moment(data.order_date).format("DD/MM/YYYY");
  //   doc.text(`Order ID: ${data.order_id || ""}`, 40, 290);
  //   doc.text(`Order Date: ${orderDate}`, 40, 305);
  //   doc.text(`Total Order Value: Rs. ${totalOrderValue}`, 40, 320);

  //   // Add Table for Order Items
  //   const tableData = orderItems.map((item, index) => [
  //     index + 1,
  //     item.product_name || "", // Product Name
  //     item.product_price || "N/A", // Product Price
  //     item.product_quantity || "N/A", // Quantity
  //     item.product_total_price || "N/A", // Total Price
  //   ]);

  //   doc.autoTable({
  //     startY: 360,
  //     head: [["S.No", "Product Name", "Unit Price", "Quantity", "Total Price"]],
  //     body: tableData,
  //     theme: "grid",
  //     margin: { top: 10 },
  //   });

  //   // Add Footer and Total Calculation
  //   const finalY = doc.lastAutoTable.finalY + 10;
  //   const amountInWords = toWords(totalOrderValue); // Assuming numberToWords function

  //   doc.setFont("helvetica", "bold");
  //   doc.text(`Total Amount: Rs. ${totalOrderValue}`, 470, finalY + 20);
  //   doc.text(`Amount in Words: ${amountInWords}`, 40, finalY + 40);

  //   doc.text(`Generated on: ${new Date().toLocaleString()}`, 40, finalY + 80);

  //   doc.save(`Invoice_${record.order_id}.pdf`);
  // };

  const generatePDF = async (record) => {
    console.log("Record:", record);

    // Fetch order details from API
    const response = await fetch(
      "https://app-tl2d3sc25q-uc.a.run.app/api/order_details",
     
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          vendorId: record.vendor_id, // Use vendor_id from the record
          orderId: record.order_id, // Use order_id from the record
        }),
      }
    );

    const data = await response.json();
    console.log("Fetched Data:", data);

    // Extract billing and items from fetched data
    const billing = data.billing || {};
    const shippng = data.shipping || {};
    const vendor = data.vendor_address || {};
    const orderItems = data.items || [];

    const doc = new jsPDF("p", "pt", "a4");

    // Add logo image
    const img = new Image();
    img.src = logo; // Assuming you have a logo variable defined
    doc.addImage(img, "PNG", 40, 40, 100, 60);

    // Title and Subtitle
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Tax Invoice/Bill of Supply/Cash Memo", 300, 50);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("(Original for Recipient)", 300, 70);
    const lineHeight = 15;

    // Sold By
    doc.setFont("helvetica", "bold");
    doc.text("SOLD BY:", 40, 130);
    doc.setFont("helvetica", "normal");
    doc.text(vendor.storeName || "", 40, 150);
    
    const vendorAddressLines = doc.splitTextToSize(vendor.address || "", 250);
    doc.text(vendorAddressLines, 40, 165);
    const vendorY = 165 + vendorAddressLines.length * lineHeight;
    doc.text(`Phone: ${vendor.phone || ""}`, 40, vendorY);
    
    // Billing Address
    doc.setFont("helvetica", "bold");
    doc.text("BILLING ADDRESS:", 350, 130);
    doc.setFont("helvetica", "normal");
    doc.text(`${billing.first_name || ""} ${billing.last_name || ""}`, 350, 150);
    
    const billingAddressLines = doc.splitTextToSize(billing.address || "", 180);
    doc.text(billingAddressLines, 350, 165);
    const billingY = 165 + billingAddressLines.length * lineHeight;
    doc.text(`Phone: ${billing.phone || ""}`, 350, billingY);
    
    // Shipping Address
    doc.setFont("helvetica", "bold");
    doc.text("SHIPPING ADDRESS:", 350, billingY + 30);
    doc.setFont("helvetica", "normal");
    doc.text(`${shippng.first_name || ""} ${shippng.last_name || ""}`, 350, billingY + 45);
    
    const shippingAddressLines = doc.splitTextToSize(shippng.address || "", 180);
    doc.text(shippingAddressLines, 350, billingY + 60);
    const shippingY = billingY + 60 + shippingAddressLines.length * lineHeight;
    doc.text(`Phone: ${shippng.phone || ""}`, 350, shippingY);
    

    // Order Details
    const orderDate = moment(data.order_date).format("DD/MM/YYYY");
    doc.text(`Order ID: ${data.order_id || ""}`, 40, 290);
    doc.text(`Order Date: ${orderDate}`, 40, 305);
    doc.text(`Invoice Date: ${moment().format("DD/MM/YYYY")}`, 40, 320);

    let totalOrderValue = 0;

    // Add Table for Order Items
    const tableData = orderItems.map((item, index) => {
      const netAmount = (item.product_price * item.product_quantity).toFixed(2);
      const taxAmount = (netAmount * 0.18).toFixed(2); // Assuming 18% tax (9% CGST + 9% SGST)
      const totalAmount = (
        parseFloat(netAmount) + parseFloat(taxAmount)
      ).toFixed(2);

      totalOrderValue += parseFloat(totalAmount); // Summing up the total order value

      return [
        index + 1,
        item.product_name || "", // Description
        item.product_price.toFixed(2) || "N/A", // Unit Price
        0, // Discount (assuming no discount)
        item.product_quantity || "N/A", // Quantity
        netAmount, // Net Amount
        "9%", // Tax Rate
        `${(netAmount * 0.09).toFixed(2)} CGST ${(netAmount * 0.09).toFixed(
          2
        )} SGST`, // Tax Amount
        totalAmount, // Total Amount
      ];
    });

    // Add Shipping Charges
    const shippingCharges = data.shipping_charges || 41; // Assuming 41 Rs as shipping charge
    if (shippingCharges > 0) {
      const shippingTaxRate = 9; // Assuming 9% CGST and 9% SGST
      const shippingTaxAmount = (
        (shippingCharges * shippingTaxRate) /
        100
      ).toFixed(2);
      const totalShippingAmount = (shippingCharges * 1.18).toFixed(2); // Including 18% tax

      totalOrderValue += parseFloat(totalShippingAmount); // Adding shipping charges to total order value

      tableData.push([
        orderItems.length + 1,
        "Shipping Charges",
        shippingCharges.toFixed(2),
        0, // No discount
        1, // Quantity of 1 for shipping
        shippingCharges.toFixed(2),
        `${shippingTaxRate}%`, // Tax Rate
        `${shippingTaxAmount} CGST ${shippingTaxAmount} SGST`, // Tax Amount
        totalShippingAmount, // Total Amount including taxes
      ]);
    }

    doc.autoTable({
      startY: 360,
      head: [
        [
          "S.No",
          "Description",
          "Unit Price in Rs.",
          "Discount in Rs.",
          "Qty",
          "Net Amount in Rs.",
          "Tax Rate",
          "Tax Amount in Rs.",
          "Total Amount in Rs.",
        ],
      ],
      body: tableData,
      theme: "grid",
      margin: { top: 10 },
    });

    // Add Footer and Total Calculation
    const finalY = doc.lastAutoTable.finalY + 10;
    const amountInWords = toWords(totalOrderValue.toFixed(2)); // Convert total order value to words

    doc.setFont("helvetica", "bold");
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.text(
      `Total Amount: Rs. ${totalOrderValue.toFixed(2)}`,
      pageWidth -200, // Positioning 20px away from the right edge
      finalY + 10
    );

    doc.text(`Amount in Words: ${amountInWords}`, 40, finalY + 40);

    doc.setFont("helvetica", "normal");
    doc.text("Thank you for shopping with us!", 40, finalY + 60);
    doc.text(
      "Note: This invoice is for the item mentioned above only.",
      40,
      finalY + 75
    );
    doc.text(
      "In case of any difficulty, please contact support@aptope.com",
      40,
      finalY + 90
    );

    doc.text(`Generated on: ${new Date().toLocaleString()}`, 40, finalY + 120);

    doc.save(`Invoice_${record.order_id}.pdf`);
  };

  const showAssignModal2 = (record) => {
    confirm({
      title: "Are you sure you want to Shipment this order?",
      content: `Order ID: ${record.order_id}`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: () => markOrderReadyForShipment(record),
    });
  };

  const formatDate = (dateString) => {
    console.log("come");
    // Use Moment.js or JavaScript Date object to format the date
    const formattedDate = moment(dateString).format("DD:MM:YYYY hh:mm A");
    return formattedDate;
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
    form.resetFields();
  };

  const handleOk2 = () => {
    form
      .validateFields()
      .then((values) => {
        const selectedStaff = staffData.find(
          (staff) => staff.id === values.staffId
        );
        assignStaffToOrder(
          values.staffId,
          selectedStaff.name,
          selectedOrder2.customer_name,
          selectedOrder2.customer_phone,
          selectedOrder2.order_id
        );
        setIsModalVisible2(false);
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const assignStaffToOrder = async (
    staffId,
    staffName,
    customerName,
    customerPhone,
    orderId
  ) => {
    try {
      const response = await fetch(
        `https://app-nm5xb3nmya-uc.a.run.app/api/assign_accountant`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            roll_acct: staffId,
            order_id: orderId,
            accountant_name: staffName,
            customer_name: customerName,
            customer_phone: customerPhone,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to assign staff to order");
      }
      message.success("Staff assigned successfully");
    } catch (error) {
      console.error("Error assigning staff to order:", error);
    }
  };

  return (
    <div className="dashboard-container">
      <Table
        columns={columns}
        dataSource={orderData}
        rowKey="id"
        scroll={{ x: 1200, y: 500 }}
      />

      <OrderDetailsModal
        visible={isModalVisible}
        order={selectedOrder}
        staffData={staffData}
        onCancel={handleCancel}
      />

      <Modal
        title="Assign Order"
        visible={isModalVisible2}
        onOk={handleOk2}
        onCancel={handleCancel2}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="staffId"
            label="Select Staff"
            rules={[
              { required: true, message: "Please select a staff member" },
            ]}
          >
            <Select placeholder="Select a staff member">
              {staffData.map((staff) => (
                <Option key={staff.id} value={staff.id}>
                  {staff.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Dashboard;
